import { ToastContentProps } from "react-toastify";
import logoSm from "../../assets/images/logo-sm.png";

import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const toastOptions = {
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  }

const CustomToast: React.FC<{ message: string }> = ({ message }) => (
    <div className="d-flex align-items-center">
        <img
            src={logoSm}
            alt="Logo"
            style={{ height: 30, marginRight: 10 }}
        />
        {message}
    </div>
);

export const showToast = (message: string, type: string) => {
    const show = type === "success" ? toast.success : type === "warning" ? toast.warn : toast.error;
    show(<CustomToast message={message} />, {
        icon: false,
        ...toastOptions,
    });
};